import styled from "@emotion/styled"
import { Positioned } from "@signal-app/ui"
import type { FC } from "react"
import { Layout } from "../../../Constants"
import { Ruler } from "../../ruler"
import { useKeyScroll } from "../hooks/useKeyScroll"
import { PianoRollCanvas } from "./canvas/PianoRollCanvas"
import { InstrumentLane } from "./InstrumentLane"
import { PianoKeys } from "./PianoKeys"

export interface PianoRollStageProps {
  width: number
  height: number
  keyWidth: number
}

const Container = styled.div``

const RulerPosition = styled(Positioned)`
  height: var(--size-ruler-height);
  background: var(--color-background);
  border-bottom: 1px solid var(--color-divider);
`

const LeftTopSpace = styled(RulerPosition)``

export const PianoRollStage: FC<PianoRollStageProps> = ({
  width,
  height,
  keyWidth,
}) => {
  const { scrollTop } = useKeyScroll()

  return (
    <Container>
      <Positioned top={Layout.rulerHeight} left={keyWidth}>
        <PianoRollCanvas width={width} height={height - Layout.rulerHeight} />
      </Positioned>
      <Positioned top={-scrollTop + Layout.rulerHeight}>
        <PianoKeys width={keyWidth} />
      </Positioned>
      <LeftTopSpace width={keyWidth} />
      <RulerPosition left={keyWidth}>
        <Ruler />
      </RulerPosition>
      <Positioned top={Layout.rulerHeight} left={keyWidth}>
        <InstrumentLane width={width} />
      </Positioned>
    </Container>
  )
}
